module.exports = ".social-icon{\n  margin-right: 10px;\n}\n\na {\n  color: snow;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact-us/floow-us/floow-us.component.css
// module id = ./src/app/contact-us/floow-us/floow-us.component.css
// module chunks = main